import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneTableService } from '../../components/kiene-table/kiene-table.service';
import { TableColumn } from '../../components/kiene-table/table-column';
import { TableDescriptor, ToolbarButton } from '../../components/kiene-table/table-descriptor';
import { TableOption } from '../../components/kiene-table/table-option';
import { ConfirmDeleteDialogComponent } from '../../dialogs/confirm-delete-dialog/confirm-delete-dialog.component';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { AddPreisgruppeComponent } from './add-preisgruppe/add-preisgruppe.component';
import { Preisgruppe } from './preisgruppen';

@Component({
    selector: 'kiene-preisgruppen',
    templateUrl: './preisgruppen.component.html',
    styleUrls: ['./preisgruppen.component.scss'],
})
export class PreisgruppenComponent implements OnInit, OnDestroy {
    tableDescriptor: TableDescriptor = new TableDescriptor();

    constructor(
        public dialog: MatDialog,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private tableService: KieneTableService,
        private messageService: MessageService,
    ) {}

    ngOnDestroy(): void {
        this.tableService = null;
    }

    ngOnInit() {
        this.tableDescriptor.headline = 'Preisgruppen';
        this.tableDescriptor.uniqueIdentifier = 'Preisgruppen';
        this.tableDescriptor.apiUrl = this.apiBaseUrl + 'preisgruppe/';
        this.tableDescriptor.searchPlaceholder = 'Preisgruppen durchsuchen';
        this.tableDescriptor.createAllowed = false;
        this.tableDescriptor.columns.push(new TableColumn('preisgruppe_id', 'ID'));
        this.tableDescriptor.columns.push(new TableColumn('bezeichnung', 'Bezeichnung'));

        this.tableDescriptor.showDetails = true;
        this.tableDescriptor.route = '/stammdaten/preisgruppen/';
        this.tableDescriptor.nameOfIdField = 'preisgruppe_id';

        this.tableDescriptor.permissionCreate = 2992;
        this.tableDescriptor.permissionView = 2991;

        this.tableDescriptor.initialSortColumn = 'preisgruppe_id';
        this.tableDescriptor.initialSortDirection = 'desc';

        this.tableDescriptor.toolbarButtons.push(new ToolbarButton(this.addPreisgruppe.bind(this), 'add', 2992));

        this.tableDescriptor.options.push(
            new TableOption(this.openAddPreisgruppeDialog.bind(this), 'Editieren', 'edit', 2992),
        );
        this.tableDescriptor.options.push(new TableOption(this.openDeleteDialog.bind(this), 'Löschen', 'delete', 2994));
    }

    public addPreisgruppe() {
        this.openAddPreisgruppeDialog(null);
    }

    openAddPreisgruppeDialog(preisgruppe: Preisgruppe) {
        let dialogRef = this.dialog.open(AddPreisgruppeComponent, {
            width: '50%',
            minWidth: '300px',
            data: { preisgruppe: preisgruppe },
        });

        dialogRef.afterClosed().subscribe(() => {
            this.tableService.reload();
        });
    }

    openDeleteDialog(preisgruppe: Preisgruppe) {
        let dialogRef = this.dialog.open(ConfirmDeleteDialogComponent, {
            width: '500px',
            data: { title: 'Preisgruppe wirklich löschen?', text: 'Preisgruppe wirklich löschen?' },
        });

        dialogRef.afterClosed().subscribe(response => {
            if (response) {
                this.tableService.deleteEntity(this.apiBaseUrl + 'preisgruppe/delete.php', preisgruppe).subscribe(
                    () => {
                        this.messageService.infoMessage('Die Preisgruppe wurde erfolgreich gelöscht!');
                        this.tableService.reload();
                    },
                    error => {
                        this.messageService.errorMessage('Die Preisgruppe konnte nicht gelöscht werden! ', error);
                    },
                );
            }
        });
    }
}
